export default [
  {
    name: "Categories",
    path: "/categories",
    meta: {
      title: "Categories",
      group: "OTT Settings",
      requiresAuth: true,
      requiresAccountTenant: true,
      accessRoles: ["accountadmin"],
    },
    redirect: {
      name: "Manage Categories",
    },
    component: (resolve) => require(["@ottSettings/pages/index.vue"], resolve),
    children: [
      {
        name: "Manage Categories",
        path: "/categories/manage",
        meta: {
          title: "Categories",
          group: "OTT Settings",
          requiresAuth: true,
          requiresAccountTenant: true,
          accessRoles: ["accountadmin"],
        },
        component: (resolve) => require(["@ottSettings/pages/manage.vue"], resolve),
      },
      {
        name: "All Categories",
        path: "/categories/all",
        meta: {
          title: "Categories",
          group: "OTT Settings",
          requiresAuth: true,
          requiresAccountTenant: true,
          accessRoles: ["accountadmin"],
        },
        component: (resolve) => require(["@ottSettings/pages/all-categories.vue"], resolve),
      },
    ],
  },
  {
    name: "CategoriesCreate",
    path: "/categories/create",
    meta: {
      title: "Create category",
      requiresAuth: true,
      accessRoles: ["accountadmin"],
      group: "OTT Settings",
    },
    component: (resolve) => require(["@ottSettings/pages/create.vue"], resolve),
  },
  {
    name: "CategoriesEdit",
    path: "/categories/:id/edit",
    meta: {
      title: "Edit category",
      requiresAuth: true,
      accessRoles: ["accountadmin"],
      group: "OTT Settings",
    },
    component: (resolve) => require(["@ottSettings/pages/_id/edit.vue"], resolve),
  },
  {
    name: "CategoriesEditBulk",
    path: "/categories/bulk",
    meta: { title: "Bulk: Edit categories", group: "OTT Settings", requiresAuth: true },
    component: (resolve) => require(["@ottSettings/pages/bulk.vue"], resolve),
  },
  {
    name: "Subscriptions",
    path: "/subscriptions",
    meta: {
      title: "Subscriptions",
      group: "OTT Settings",
      requiresAuth: true,
      requiresAccountTenant: true,
      accessRoles: ["accountadmin"],
    },
    component: (resolve) => require(["@ottSettings/pages/subscriptions.vue"], resolve),
  },
  {
    name: "SubscriptionCreate",
    path: "/subscriptions/create",
    meta: {
      title: "Create subscription",
      requiresAuth: true,
      accessRoles: ["accountadmin"],
      group: "OTT Settings",
    },
    component: (resolve) => require(["@ottSettings/pages/create-subscription.vue"], resolve),
  },
  {
    name: "SubscriptionEdit",
    path: "/subscriptions/:id/edit",
    meta: {
      title: "Edit subscription",
      requiresAuth: true,
      accessRoles: ["accountadmin"],
      group: "OTT Settings",
    },
    component: (resolve) => require(["@ottSettings/pages/_id/edit-subscription.vue"], resolve),
  },
  {
    name: "General Settings",
    path: "/general-settings",
    meta: {
      title: "General Settings",
      group: "OTT Settings",
      requiresAuth: true,
      requiresAccountTenant: true,
      accessRoles: ["accountadmin"],
    },
    redirect: {
      name: "Manage Sport Types",
    },
    component: (resolve) => require(["@ottSettings/pages/general-settings.vue"], resolve),
    children: [
      {
        name: "Manage Sport Types",
        path: "/general-settings/sport-types",
        meta: {
          title: "General Settings",
          group: "OTT Settings",
          requiresAuth: true,
          requiresAccountTenant: true,
          accessRoles: ["accountadmin"],
        },
        component: (resolve) => require(["@ottSettings/pages/manage-sport-types.vue"], resolve),
      },
      {
        name: "Restrictions",
        path: "/general-settings/restrictions",
        meta: {
          title: "General Settings",
          group: "OTT Settings",
          requiresAuth: true,
          requiresAccountTenant: true,
          accessRoles: ["accountadmin"],
        },
        component: (resolve) => require(["@ottSettings/pages/restrictions.vue"], resolve),
      },
      {
        name: "Graphics",
        path: "/general-settings/graphics",
        meta: {
          title: "General Settings",
          group: "OTT Settings",
          requiresAuth: true,
          requiresAccountTenant: true,
          accessRoles: ["accountadmin"],
        },
        component: (resolve) => require(["@ottSettings/pages/graphics.vue"], resolve),
      },
      {
        name: "Homepage",
        path: "/general-settings/homepage",
        meta: {
          title: "Homepage",
          group: "OTT Settings",
          requiresAuth: true,
          requiresAccountTenant: true,
          accessRoles: ["accountadmin"],
        },
        component: (resolve) => require(["@ottSettings/pages/homepage.vue"], resolve),
      },
    ],
  },
  {
    name: "Ads",
    path: "/ads",
    meta: {
      title: "Ads",
      group: "OTT Settings",
      requiresAuth: true,
      requiresAccountTenant: true,
      accessRoles: ["accountadmin"],
    },
    component: (resolve) => require(["@ottSettings/pages/ads.vue"], resolve),
  },
  {
    name: "AdsCreate",
    path: "/ads/create",
    meta: {
      title: "Create Ad",
      requiresAuth: true,
      accessRoles: ["accountadmin"],
      group: "OTT Settings",
    },
    component: (resolve) => require(["@ottSettings/pages/create-ad.vue"], resolve),
  },
  {
    name: "AdsEdit",
    path: "/ads/:id/edit",
    meta: {
      title: "Edit ad",
      requiresAuth: true,
      accessRoles: ["accountadmin"],
      group: "OTT Settings",
    },
    component: (resolve) => require(["@ottSettings/pages/_id/edit-ad.vue"], resolve),
  },
];
